import { Outlet } from 'react-router-dom'
import React from 'react'

const Commitment = () => {
  return (
    <Outlet/>
  )
}

export default Commitment